import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Map Preview',
  attributeName: 'camerasPreview',
  validationUrl:'live',
  fields: [
    // {
    //   attributeName: 'cameras',
    //   type: FormInputTypes.JSON_COMPONENT,
    //   canCreate: false,
    //   canRemove:false,
    //   canEdit:false,
    //   emptyMessage: "You don't have any view point yet.",
    //   columns:1,
    //   label: 'Cameras',
    //   itemLabel:'Cameras',
    //   required: true,
    //   helpText: 'Insert new view points clicking in + button.',
    //   errorText: '',
    //   popupFormGroups:[
    //     CamerasFields
        

    //   ]
    // },
    {
      attributeName: 'cameras',
      type: FormInputTypes.CAMERAS_PRESENTATION,
      emptyMessage: "You don't have any view point yet.",
      label: 'Cameras',
      itemLabel:'Cameras',
      required: true,
      helpText: 'Insert new view points clicking in + button.',
      errorText: '',
    },
  ]
};